import React from "react";
import Moment from "react-moment";

import { connect } from "react-redux";

import ZeeTable from "components/ZeeTable";

import {
  create,
  update,
  remove,
  createSupplier,
  updateSupplier,
  removeSupplier,
} from "reducers/stock";

import StockSupplierService from "services/stock-supplier";

class Stock extends React.Component {
  stockSupplierService = new StockSupplierService();

  columns = {
    name: { name: "Supplier", noEdit: true },
    partnumber: { name: "Part Number" },
  };

  async onDelete(stockSupplier) {
    const result = await this.stockSupplierService
      .delete(stockSupplier)
      .then(({ data }) => data);

    if (result.success) {
      this.props.removeSupplier(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(stockSupplier) {
    const result = await this.stockSupplierService
      .update(stockSupplier)
      .then(({ data }) => data);

    if (result.success) {
      this.props.updateSupplier(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(stockSupplier) {
    const result = await this.stockSupplierService
      .create(stockSupplier)
      .then(({ data }) => data);

    if (result.success) {
      this.props.createSupplier(result.data);
      return result.data;
    }
    return false;
  }

  onRowDoubleClick(item) {
    const { history } = this.props;

    history.push(`/stock/${this.currentId}/supplier/${item.id}`);
  }

  getAdditionalDataFromStockSupplierRelationship(id) {
    const result = this.props.stockSupplier.find(
      (item) => item.supplier_id === id && item.stock_id === this.currentId
    );

    if (!result) {
      return {};
    }

    const { partnumber, created, updated } = result;

    return {
      partnumber,
      created,
      updated,
    };
  }

  get currentId() {
    return this.props.stock.id || null;
  }

  get currentItem() {
    return this.props.stock || null;
  }

  get supplier() {
    return this.props.supplier.map(({ id, name }) => ({
      id,
      name,
    }));
  }

  get data() {
    return this.supplier.map((item) => ({
      ...item,
      ...this.getAdditionalDataFromStockSupplierRelationship(item.id),
    }));
  }

  get selected() {
    return this.props.stockSupplier
      .filter((item) => item.stock_id === this.currentId)
      .map((item) => item.supplier_id);
  }

  get mySuppliers() {
    return this.props.stockSupplier.filter(
      (item) => item.stock_id === this.currentItem.id
    );
  }

  getMySupplierById(supplierId) {
    return this.mySuppliers.find((item) => item.supplier_id === supplierId);
  }

  getItemsToAdd(selection, data) {
    return selection
      .reduce(
        (agg, item) =>
          this.selected.filter((id) => id === item).length === 0
            ? [...agg, item]
            : agg,
        []
      )
      .map((id) => ({
        id: 0,
        stock_id: parseInt(this.currentId),
        supplier_id: parseInt(id),
        ...data.find((item) => item.supplier_id === id),
      }));
  }

  getItemsToEdit(selection, data) {
    return selection
      .reduce(
        (agg, item) =>
          this.selected.filter((id) => id === item).length > 0
            ? [...agg, item]
            : agg,
        []
      )
      .map((id) => ({
        ...this.getMySupplierById(id),
        stock_id: parseInt(this.currentId),
        supplier_id: parseInt(id),
        ...data.find((item) => item.supplier_id === id),
      }));
  }

  getItemsToDelete(selection) {
    return this.selected
      .reduce(
        (agg, item) =>
          selection.filter((id) => id === item).length === 0
            ? [...agg, item]
            : agg,
        []
      )
      .map((id) => this.getMySupplierById(id));
  }

  onSelection(selection, data) {
    data = data.map(({ id, partnumber }) => ({
      supplier_id: id,
      partnumber,
    }));

    const toDelete = this.getItemsToDelete(selection);
    const toAdd = this.getItemsToAdd(selection, data);
    const toEdit = this.getItemsToEdit(selection, data);

    toEdit.forEach((item) => this.onEdit(item));
    toDelete.forEach((item) => this.onDelete(item));
    toAdd.forEach((item) => this.onAdd(item));
  }

  render() {
    return (
      <React.Fragment>
        <ZeeTable
          title="Suppliers"
          columns={this.columns}
          data={this.data}
          selected={this.selected}
          onRowClick={() => null}
          onRowDoubleClick={(item) => this.onRowDoubleClick(item)}
          hasSelection={true}
          hasMultipleSelection={true}
          hasPagination={true}
          orderBy="name"
          onSelectionConfirm={(selection, data) =>
            this.onSelection(selection, data)
          }
          isEditing={true}
          confirmText="Save"
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      all: state.stock.all,
      stockSupplier: state.stock.supplier.all,
      supplier: state.supplier.all,
    };
  },
  { updateSupplier, createSupplier, removeSupplier }
)(Stock);
